export default function validateStage() {
  let hrefCarousel = '#carouselExampleIndicators';
  colorDots();
  
  function colorDots(button) {
    let verifyActive = true;
    $('.carousel-indicators li').removeClass('color');

    $.each($('.carousel-indicators li'), function (key, el) {
      if (verifyActive) {
        $(el).addClass('color');
      }
      if ($(el).hasClass('active')) {
        verifyActive = false;
        if (button === 'prev') {
          $(el).removeClass('color');
        }
      }
    });
  }

  function validateSelect(btnNext) {
    let elementRequired = btnNext.closest('.carousel-item').find('*:required');
    let count = 0;
    $.each(elementRequired, function (key, el) {
      if ($(el).val() === '') {
        count++;
      }
    })
    if (count === 0) {
      btnNext.attr('href', hrefCarousel);
    } else {
      btnNext.attr('href', '');
      Swal.fire({
        title: jsi18n.form_invalid_title,
        text: jsi18n.form_invalid_message,
        imageUrl: site_url + 'site/img/iconError.png',
        imageWidth: 76,
        imageHeight: 76
      });
    }
    return count;
  }
  $('.carousel-control-next-modal').click(function (e) {
    e.preventDefault();
    let count = validateSelect($(this));
    let unit = $('#sac select._unit').val();
    colorDots();
    if(count === 0 && unit =='utilidades'){
      $('.politic-modal').modal('show');
    }
  });
  $('.carousel-control-next').click(function (e) {
    e.preventDefault();
    validateSelect($(this));
    colorDots();
  });
  $('.carousel-control-prev').click(() => colorDots('prev'));
}